import { render } from "./APPPassword.vue?vue&type=template&id=be6d6622"
import script from "./APPPassword.vue?vue&type=script&lang=js"
export * from "./APPPassword.vue?vue&type=script&lang=js"

import "./APPPassword.vue?vue&type=style&index=0&id=be6d6622&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__